import { useMemo } from 'react';

function getSizeCss(size) {
    switch (size) {
        case 'small':
            return 'py-3 px-3';
        case 'large':
            return 'py-5 px-14';
        default:
            return 'min-h-50 py-3 px-6';
    }
}
function getVariantCss(variant, filled) {
    const styles = {
        primary: 'border-green hover:border-green-600 hover:bg-green-600 hover:text-white',
        light: 'border-white hover:border-lilac-300 hover:bg-lilac-300 hover:text-black',
        dark: 'border-gray-900 hover:border-gray-500 hover:bg-gray-500 hover:text-white',
        danger: 'border-red hover:border-red-700 hover:bg-red-700 hover:text-white',
        secondary: 'border-lilac-300 hover:border-lilac-500 hover:bg-lilac-500 hover:text-white',
        tertiary: 'border-indigo-500 hover:border-lilac-500 hover:bg-lilac-500 hover:text-white',
        gradient: 'bg-gradient-to-tr hover:bg-green hover:text-black',
    };
    switch (variant) {
        case 'light':
            return filled ? `bg-white ${styles.light}` : `text-white ${styles.light}`;
        case 'dark':
            return filled ? `bg-gray-900 text-white ${styles.dark}` : styles.dark;
        case 'danger':
            return filled
                ? `bg-red text-white ${styles.danger}`
                : `text-red ${styles.danger}`;
        case 'secondary':
            return filled ? `bg-lilac-300 ${styles.secondary}` : styles.secondary;
        case 'tertiary':
            return filled
                ? `bg-indigo-500 text-white ${styles.tertiary}`
                : styles.tertiary;
        case 'gradient':
            return filled
                ? `from-lilac-300 to-green hover:from-green hover:to-green border-none ${styles.gradient}`
                : `${styles.gradient} border-gradient-tr-lilac-green`;
        default:
            return filled ? `bg-green ${styles.primary}` : styles.primary;
    }
}
const useButtonStyles = ({ disabled, filled, rounded, size = 'medium', variant = 'primary', }) => {
    const styles = useMemo(() => {
        return [
            'inline-grid gap-x-2 grid-flow-col items-center justify-center text-center',
            'text-sm font-heading transition-colors focus:outline-none outline-none cursor-pointer leading-none border',
            rounded ? 'rounded-md' : '',
            getSizeCss(size),
            disabled
                ? 'border-gray-300 bg-gray-300 text-gray-500 hover:text-gray-500 cursor-not-allowed'
                : getVariantCss(variant, filled),
        ].join(' ');
    }, [disabled, filled, rounded, size, variant]);
    return styles;
};

export { useButtonStyles };
//# sourceMappingURL=useButtonStyles.js.map
